// Single-vision "Both" sale: two pairs of glasses — pair 1 for far vision,
// pair 2 for close up. The prescription step picks a lens for each
// (selectedLens / selectedLensNear) and makes a draft order for each
// (orderId / orderIdNear). The frame and measures pages show both pairs side
// by side; pair 2 keeps its frame and measures under the same keys with a
// "Near" suffix. Payment joins both into one total, and the confirmation page
// saves two linked orders under one payment.

export const isTwoPairSale = () => !!sessionStorage.getItem('selectedLensNear');

// selectedFrame → selectedFrameNear, orderId → orderIdNear, …
export const pairSessionKey = (base, pair) => (pair === 'near' ? `${base}Near` : base);

const readJson = (key, fallback = null) => {
  try { return JSON.parse(sessionStorage.getItem(key) || 'null') ?? fallback; } catch (_) { return fallback; }
};

// One pair's lens, frame, extras, adjustments and measures.
export function pairStepData(pair) {
  const k = (base) => pairSessionKey(base, pair);
  return {
    selectedFrame: readJson(k('selectedFrame'), {}),
    frameSelectionData: readJson(k('frameSelectionData'), {}),
    extraFrames: readJson(k('extraFrames'), []),
    measurementFormData: readJson(k('measurementFormData'), {}),
    selectedLens: readJson(k('selectedLens')),
    draftOrder: readJson(k('orderData')),
    orderId: sessionStorage.getItem(k('orderId')),
  };
}

export const PAIR_SESSION_KEYS = [
  'selectedLensNear', 'orderIdNear', 'orderDataNear', 'orderNumberNear',
  'selectedFrameNear', 'frameSelectionDataNear', 'extraFramesNear',
  'measurementDataNear', 'measurementFormDataNear', 'pairOrders',
];
